import request from '@/utils/request'


// 查询岗位专区列表
export function listPrecinct(query) {
  return request({
    url: '/user/post-precinct/list',
    method: 'get',
    params: query
  })
}

// 查询岗位专区分页
export function pagePrecinct(query) {
  return request({
    url: '/user/post-precinct/page',
    method: 'get',
    params: query
  })
}

// 查询岗位专区详细
export function getPrecinct(data) {
  return request({
    url: '/user/post-precinct/detail',
    method: 'get',
    params: data
  })
}

// 新增岗位专区
export function addPrecinct(data) {
  return request({
    url: '/user/post-precinct/add',
    method: 'post',
    data: data
  })
}

// 修改岗位专区
export function updatePrecinct(data) {
  return request({
    url: '/user/post-precinct/edit',
    method: 'post',
    data: data
  })
}

// 删除岗位专区
export function delPrecinct(data) {
  return request({
    url: '/user/post-precinct/delete',
    method: 'post',
    data: data
  })
}
